import { render, staticRenderFns } from "./RiskStrata.vue?vue&type=template&id=a96de8c8&"
import script from "./RiskStrata.vue?vue&type=script&lang=js&"
export * from "./RiskStrata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports